import {AI_ASSISTANT_EXTENSION_ID, extensionStore} from "@project/app-state";
import {Store} from "@tanstack/react-store";

const MOBILE_VIEWPORT_QUERY = "(max-width: 1023px)";

export interface AssistantMobileFlowState {
  pendingReturnToAssistant: boolean;
  clearPendingReturnToAssistant: () => void;
  setPendingReturnToAssistant: (value: boolean) => void;
}

export const assistantMobileUIStore = new Store<AssistantMobileFlowState>({
  pendingReturnToAssistant: false,

  clearPendingReturnToAssistant: () => {
    assistantMobileUIStore.setState((state) => ({
      ...state,
      pendingReturnToAssistant: false,
    }));
  },

  setPendingReturnToAssistant: (value: boolean) => {
    assistantMobileUIStore.setState((state) => ({
      ...state,
      pendingReturnToAssistant: value,
    }));
  },
});

export function isMobileAssistantViewport(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;

  return window.matchMedia(MOBILE_VIEWPORT_QUERY).matches;
}

export function isAssistantVisibleOnMobile(): boolean {
  return (
    isMobileAssistantViewport() &&
    extensionStore.state.isOpen &&
    extensionStore.state.activeExtension === AI_ASSISTANT_EXTENSION_ID
  );
}

export function focusAppOnMobile(): boolean {
  if (!isMobileAssistantViewport()) return false;

  extensionStore.state.focusApp();

  return true;
}

export function focusAssistantOnMobile(): boolean {
  if (!isMobileAssistantViewport()) return false;

  extensionStore.state.focusAssistant();

  return true;
}
